"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { component } from "@gnist/component-utils";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { Heading3Text } from "../../../foundation/typography/index.js";
import { forwardRef } from "react";
import "classnames";
import "../../../foundation/logos/Logo.css.js";
import { atoms } from "@gnist/themes/atoms.css.js";
import { head, headBackground, body, accordionRecipe } from "./accordion.css.js";
const AccordionElement = forwardRef(function AccordionElement2({ head: head$1, expanded, children, ...props }, ref) {
  const headElement = typeof head$1 === "string" ? jsx(Heading3Text, { className: atoms({ typography: "heading3-small" }), children: head$1 }) : head$1;
  return jsx(Fragment, { children: jsxs("details", { ...props, open: expanded, ref, children: [jsxs("summary", { className: head, children: [jsx("div", { className: headBackground }), headElement, jsx(Icon, { icon: "expand_more" })] }), jsx("div", { className: body, children })] }) });
});
const Accordion = component("Accordion", accordionRecipe, AccordionElement);
export {
  Accordion
};
